import configData from "../config.json";

/**
 * Resolve an image coming from the API into a usable <img src>.
 * Supports:
 *  - relative server paths  -> {SERVER_URL}/api/employee_image/12
 *  - absolute urls          -> http(s)://...
 *  - data uris              -> data:image/...
 *  - raw base64 (legacy)    -> data:image/jpeg;base64,...
 */
export const resolveImageSrc = (value, fallback = "/vnn_1.jpg") => {
  if (!value || typeof value !== "string") return fallback;
  const trimmed = value.trim();
  if (!trimmed) return fallback;
  if (trimmed.startsWith("data:")) return trimmed;
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) return trimmed;
  if (trimmed.startsWith("/")) return `${configData.SERVER_URL}${trimmed}`;
  // Treat as raw base64: validate characters before calling atob
  const base64Regex = /^[A-Za-z0-9+/=]+$/;
  if (!base64Regex.test(trimmed.replace(/\s/g, ""))) return fallback;
  try {
    const decoded = atob(trimmed);
    const codes = Array.from(decoded.slice(0, 12), (char) => char.charCodeAt(0));
    const mime =
      codes[0] === 0xff && codes[1] === 0xd8 && codes[2] === 0xff
        ? "image/jpeg"
        : codes[0] === 0x89 && codes[1] === 0x50 && codes[2] === 0x4e && codes[3] === 0x4e
          ? "image/png"
          : decoded.startsWith("GIF8")
            ? "image/gif"
            : decoded.startsWith("RIFF") && decoded.slice(8, 12) === "WEBP"
              ? "image/webp"
              : null;
    return mime ? `data:${mime};base64,${trimmed}` : `data:image/jpeg;base64,${trimmed}`;
  } catch (e) {
    return fallback;
  }
};

export default resolveImageSrc;
